module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Link ESRS Topics"},"de":{"title":"ESRS Themen verlinken"}}')
  delete Component.options._Ctor
}
